import { Alert, AlertTitle, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../../../constants/translations';
import { useAdmin } from '../../../contexts/admin.context';
import { useCafe } from '../../../contexts/cafe.context';
import { useLocale } from '../../../contexts/locale.context';
import PrimaryButton from '../../PrimaryButton';

const EndPlan = () => {
  const { lang } = useLocale();
  const { cafe, cafeSlug } = useAdmin();
  const { setOpenMessages } = useCafe();
  const navigate = useNavigate();

  const goToPlanSettings = useCallback(() => {
    navigate(`/${cafeSlug}/restaurant?tab=plan`);
    setOpenMessages(false);
  }, [cafeSlug, navigate, setOpenMessages]);

  return (
    <Alert severity="warning" color="warning" sx={{ mb: 2 }}>
      <AlertTitle>{`${t.attention[lang]}`} </AlertTitle>

      <Typography>{`${t.subscription_expires_on[lang]} ${format(
        cafe?.plan?.lastDate || Date.now(),
        'dd.MM.yyyy'
      )}`}</Typography>

      <PrimaryButton size="small" variant="contained" onClick={goToPlanSettings} sx={{ mt: 2 }}>
        {t.extend_subscription[lang]}
      </PrimaryButton>
    </Alert>
  );
};

export default EndPlan;
